/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/08/10 09:15
 * @update 2026/08/10 09:15
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { ButtonIcon, Col, DatePicker, Dropdown, Row, Typography, Checkbox } from 'diginet-core-ui/components';
import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/user-actions";
import * as W14F1020Actions from "../../../actions/w14/w14F1020/w14F1020-actions";
import * as W07F6699Actions from "../../../actions/w07/W07F6699/W07F6699-actions";
import * as LoopRequestApiActions from "../../../actions/system/loop-request-api";
import Config from "../../../config";
import ButtonExport from '../../common/button/button-export';
import GridActionBar from "../../common/action-bar/grid-action-bar-hover";
import GridContainer from "../../common/grid-container/grid-container";
import ActionToolbar from "../../common/tool-bar/action-toolbar";
import W14F1020UpdateStatus from "./W14F1020UpdateStatus";

const FormID = 'W14F1020';

const W14F1020 = (props) => {
    const [iPermission, setIPermission] = useState(null);
    const [paymentPermission, setPaymentPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [cboPeriodFromLoading, setCboPeriodFromLoading] = useState(false);
    const [cboGroupSaleLoading, setCboGroupSaleLoading] = useState(false);
    const [cboSalesPersonLoading, setCboSalesPersonLoading] = useState(false);
    const [cboPeriodToLoading, setCboPeriodToLoading] = useState(false);
    const [cboStatusLoading, setCboStatusLoading] = useState(false);
    const [cboUpDateStatusLoading, setCboUpdateStatusLoading] = useState(false);
    const [checkBoxHeaderStatus, setCheckBoxHeaderStatus] = useState(false);
    const [openUpdateStatus, setUpdateStatus] = useState(false);
    const [isEnableUpdateStatus, setIsEnableUpdateStatus] = useState({IsEnable: false, dataIsCheck: []});
    const [cboObjectLoading, setCboObjectLoading] = useState(false);
    const [isCheckedAll, setIsCheckedAll] = useState(0);

    const exportRef = useRef(null);
    const gridDetailRef = useRef(null);

    const [search, setSearch] = useState('');
    const [dataFilter, setDataFilter] = useState({
        DateFrom: null,
        DateTo: null,
        IsDate: 1, // default Check
        IsPeriod: 0,
        PeriodFrom: '',
        PeriodFromName: '',
        PeriodTo: '',
        PeriodToName: '',
        GroupSalesID: '',
        SalesPersonID: '',
        StatusID: '',
        ObjectID: "",
        IsPaymentChannels: null
    });
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboPeriodFrom, setDataCboPeriodFrom] = useState([]);
    const [dataCboPeriodTo, setDataCboPeriodTo] = useState([]);
    const [dataCboGroupSales, setDataCboGroupSales] = useState([]);
    const [dataCboSalesPerson, setDataCboSalesPerson] = useState([]);
    const [dataCboStatus, setDataCboStatus] = useState([]);
    const [dataCboObject, setDataCboObject] = useState([]);
    const [dataCboUpdateStatus, setDataCboUpdateStatus] = useState([]);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadPermissionPayment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    useEffect(() => {
        if (!iPermission) return;
        loadGrid();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, search, dataFilter]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (iPer) => {
            setIPermission(iPer)
        });
    };

    const loadPermissionPayment = () => {
        props.W14F1020Actions.loadPermissionPayment({ FormID }, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setPaymentPermission(data?.IsPermission);
            }
        });
    };

    const loadGrid = () => {
        const params = getParamGeneral('loadGrid');
        setFormLoading(true);
        props.W14F1020Actions.loadGrid(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                let statusCheckedAll = true;
                let checkBoxAllStatus = true;
                const dataCustom = data.map((item, idx) => {
                    if (!item?.Choose) statusCheckedAll = false;
                    if (!item?.IsPayment) checkBoxAllStatus = false;
                    return ({ ...item, STT: idx })
                });
                if (!Config.isEmpty(data) && statusCheckedAll) setIsCheckedAll(1);
                setCheckBoxHeaderStatus(checkBoxAllStatus);
                setDataGrid(dataCustom || []);
            }
        });
    };

    const onOpenLoaded = () => {
        loadCboPeriod('CmbPeriodF');
        loadCboPeriod('CmbPeriodT');
        loadCboGeneral('GroupSales');
        loadCboGeneral('SalePerson');
        loadCboGeneral('Status');
        loadCboGeneral('LoadObject');
    };

    const onOpenFilter = (status) => {
        setOpenFilter(status);
    };

    const getParamGeneral = (type, data) => {
        const { IsDate, IsPeriod, PeriodFromName, PeriodToName, ...restDataFilter } = dataFilter || {};
        let params = {
            DateFrom: null,
            DateTo: null,
            PeriodFrom: '',
            PeriodTo: '',
            CommissionID: '',
            GroupSalesID: '',
            SalesPersonID: '',
            DataTypeID: type,
            IsDate,
            IsPeriod,
            StatusID: '',
            StrSearch: search,
        };
        switch (type) {
            case 'loadGrid':
            case 'export':
                params = { ...params, ...restDataFilter };
                break;
            case 'Delete':
                const { CommissionID = '', TransID = '' } = data;
                params = { ...params, CommissionID, TransID };
                break;
            case 'LoadPovStatus':
            case 'LoadObject':
                const { IsDate, IsPeriod, PeriodFrom, PeriodTo, StatusID, ...restParams } = params;
                params = { ...restParams };
                break;
            default:
                break;
        }
        return params;
    };

    const getParamW07F6699 = (type) => {
        const { IsDate, DateFrom = null, DateTo = null, IsPeriod, PeriodFrom = '', PeriodTo = '' } = dataFilter;
        let params = {
            DataType: type,
            IsDate,
            DateFrom,
            DateTo,
            IsPeriod,
            PeriodFrom,
            PeriodTo,
            ReportID: '',
            WareHouseID: '',
            TxtINVID: '',
        };
        return params;
    };

    const handleRedirect = (mode, dataRow = {}) => {
        browserHistory.push({
            pathname: Config.getRootPath() + 'W14F1021',
            state: {
                mode,
                ...dataRow
            }
        });
    };

    const handleSetLoadingDataCbo = (fieldName, status) => {
        switch (fieldName) {
            case 'CmbPeriodF':
                if (Config.typeOf(status, 'boolean')) setCboPeriodFromLoading(status);
                else setDataCboPeriodFrom(status);
                break;
            case 'CmbPeriodT':
                if (Config.typeOf(status, 'boolean')) setCboPeriodToLoading(status);
                else setDataCboPeriodTo(status);
                break;
            case 'GroupSales':
                if (Config.typeOf(status, 'boolean')) setCboGroupSaleLoading(status);
                else setDataCboGroupSales(status);
                break;
            case 'SalePerson':
                if (Config.typeOf(status, 'boolean')) setCboSalesPersonLoading(status);
                else setDataCboSalesPerson(status);
                break;
            case 'Status':
                if (Config.typeOf(status, 'boolean')) setCboStatusLoading(status);
                else setDataCboStatus(status);
                break;
            case 'LoadPovStatus':
                if (Config.typeOf(status, 'boolean')) setCboUpdateStatusLoading(status);
                else setDataCboUpdateStatus(status);
                break;
            case 'LoadObject':
                if (Config.typeOf(status, 'boolean')) setCboObjectLoading(status);
                else setDataCboObject(status);
                break;
            default:
                break;
        }
    };

    const loadCboPeriod = (dataType) => {
        handleSetLoadingDataCbo(dataType, true);
        props.W07F6699Actions.loadGrid(getParamW07F6699(dataType), (error, data) => {
            handleSetLoadingDataCbo(dataType, false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) handleSetLoadingDataCbo(dataType, data);
        });
    };

    const loadCboGeneral = (dataType) => {
        handleSetLoadingDataCbo(dataType, true);
        props.W14F1020Actions.loadComboGeneral(getParamGeneral(dataType), (error, data) => {
            handleSetLoadingDataCbo(dataType, false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) handleSetLoadingDataCbo(dataType, data);
        });
    };

    const onUpdateStatus = async () => {
        setUpdateStatus(true);
        loadCboGeneral('LoadPovStatus');
    };

    const onRequestPayment = async () => {
        let dataSource = dataGrid;
        await gridDetailRef.current.instance.saveEditData();
        dataSource = gridDetailRef.current.instance.option('dataSource') || [];
        if (!Config.isEmpty(dataSource)) dataSource = dataSource.filter(item => item?.Choose);
        if (Config.isEmpty(dataSource)) return Config.popupCore.show('INFO', Config.lang('Vui_long_chon_du_lieu'));
        const params = { paymentRequests: dataSource };
        setFormLoading(true);
        props.LoopRequestApiActions.eventSteams(Config.env.api + '/w14f1020/payment-requests', params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { Status, Message } = data || {};
                if (Status === 0) loadGrid();
                else if (Message) Config.popupCore.show('INFO', Message);
            }
        });
    };

    const deleteRow = (e) => {
        if (!e) return;
        Config.popupCore.show('YES_NO', `${Config.lang('Ban_co_chac_chan_muon_xoa_du_lieu_nay')}`, () => {
            setFormLoading(true);
            props.W14F1020Actions.deleteRow(getParamGeneral('Delete', e?.data), (error, data) => {
                setFormLoading(false);
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return false;
                } else if (data) {
                    if (data?.Status === 0) {
                        Config.notify.show('success', Config.lang('Du_lieu_da_xoa_thanh_cong'), 2000);
                        loadGrid();
                    } else if (data?.Message) Config.popupCore.show('WARNING', data.Message);
                }
            });
        });
    };

    const renderButtonAction = (e) => {
        if (!e) return null;
        return (
            <GridActionBar>
                <div className={"display_row align-center"}>
                    <ButtonIcon
                        circular
                        viewType={"text"}
                        name={"View"}
                        title={Config.lang('Xem')}
                        disabled={iPermission <= 2}
                        onClick={() => handleRedirect('view', e?.data)}
                    />
                    <ButtonIcon
                        circular
                        disabled={iPermission <= 3}
                        name={'Delete'}
                        viewType={'text'}
                        onClick={() => deleteRow(e)} />
                </div>
            </GridActionBar>
        )
    };

    const btnCRM = [
        {
            buttonName: Config.lang('Cap_nhat_trang_thai'),
            buttonType: 'button',
            icon: 'SyncHorizontal',
            color: 'primary',
            align: 'right',
            disabled: !isEnableUpdateStatus?.IsEnable,
            onClick: () => onUpdateStatus()
        },
        {
            buttonName: Config.lang('Yeu_cau_thanh_toan'),
            buttonType: 'button',
            icon: 'Payment',
            color: 'primary',
            align: 'right',
            disabled: paymentPermission <= 0,
            onClick: () => onRequestPayment()
        },
        {
            buttonName: Config.lang("Xuat_du_lieu"),
            buttonType: 'button',
            icon: 'Sheet',
            color: 'primary',
            align: 'right',
            disabled: false,
            className: 'mgl1x',
            onClick: () => {
                if (exportRef.current.getWrappedInstance().onClick) {
                    exportRef.current.getWrappedInstance().onClick("0")
                }
            }
        }];

    const onSearch = (text = '') => {
        setSearch(text);
    };

    const onChangeFilter = (keyName, e) => {
        if (!e || !keyName) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        let objPlus = { ...dataFilter, [keyName]: value };
        if (keyName === 'IsDate') objPlus = { ...objPlus, [keyName]: +value, IsPeriod: +!value };
        else if (keyName === 'IsPeriod') objPlus = { ...objPlus, [keyName]: +value, IsDate: +!value };
        else if (['PeriodFrom', 'PeriodTo'].includes(keyName)) objPlus = { ...objPlus, [`${keyName}Name`]: e?.data?.PeriodName };
        setDataFilter(objPlus);
    };

    const toMonthValue = value => {
        let [month, year] = value.split('-');
        if (month.length === 1) month = 0 + month;
        return Number(year + month);
    };

    const dataCboPeriodFromFilter = useCallback(() => {
        return dataFilter.PeriodToName ? dataCboPeriodFrom.filter(item => toMonthValue(item?.PeriodName) <= toMonthValue(dataFilter.PeriodToName)) : dataCboPeriodFrom;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataFilter.PeriodToName, dataCboPeriodFrom]);

    const dataCboPeriodToFilter = useCallback(() => {
        return dataFilter.PeriodFromName ? dataCboPeriodTo.filter(item => toMonthValue(item?.PeriodName) >= toMonthValue(dataFilter.PeriodFromName)) : dataCboPeriodTo;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataFilter.PeriodFromName, dataCboPeriodTo]);

    const filterRender = () => {
        return <Row>
            <Col xs={12} sm={12} md={6} lg={4}>
                <Row>
                    <Col xs={12} sm={6}>
                        <Row>
                            <Col xs={12} sm={4} className={'pdl0'} verticalAlign={"center"} >
                                <Checkbox
                                    className="mgl4x"
                                    label={Config.lang('Ngay')}
                                    labelProps={{ type: "h4", color: 'text/label' }}
                                    checked={Number(dataFilter?.IsDate) === 1}
                                    onChange={(e) => onChangeFilter("IsDate", e)}
                                />
                            </Col>
                            <Col xs={12} sm={8}>
                                <DatePicker
                                    clearAble
                                    viewType={'outlined'}
                                    displayFormat={"DD/MM/YYYY"}
                                    disabled={dataFilter?.IsDate !== 1}
                                    placeholder={Config.lang('Tu')}
                                    max={dataFilter?.DateTo}
                                    value={dataFilter?.DateFrom}
                                    className={'full_w'}
                                    onChange={e => onChangeFilter('DateFrom', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={2} className={"pdl0 display_row valign-middle"}>
                                <Typography className="mgr1x" type='p1' color={'text/label'} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                            </Col>
                            <Col xs={12} sm={10} className={'pdl0'}>
                                <DatePicker
                                    clearAble
                                    viewType={'outlined'}
                                    displayFormat={"DD/MM/YYYY"}
                                    disabled={dataFilter?.IsDate !== 1}
                                    placeholder={Config.lang('Den')}
                                    min={dataFilter?.DateFrom}
                                    value={dataFilter?.DateTo}
                                    onChange={e => onChangeFilter('DateTo', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={2}>
                        <Typography className="mgr4x" type='h4' color={'text/label'} style={{ whiteSpace: 'nowrap' }}>{Config.lang('Nhom_doi_tuong')}</Typography>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Dropdown
                            clearAble
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'GroupSalesID'}
                            displayExpr={'GroupSalesName'}
                            loading={cboGroupSaleLoading}
                            dataSource={dataCboGroupSales}
                            value={dataFilter?.GroupSalesID}
                            onChange={e => onChangeFilter('GroupSalesID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={2}>
                        <Typography className="mgr4x" type='h4' color={'text/label'} style={{ whiteSpace: 'nowrap' }}>{Config.lang('Doi_tuong')}</Typography>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Dropdown
                            clearAble
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'ObjectID'}
                            displayExpr={'ObjectName'}
                            loading={cboObjectLoading}
                            dataSource={dataCboObject}
                            value={dataFilter?.ObjectID}
                            onChange={e => onChangeFilter('ObjectID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4}>
                <Row>
                    <Col xs={12} sm={6}>
                        <Row>
                            <Col xs={12} sm={4} className={'pdl0'} verticalAlign={"center"} >
                                <Checkbox
                                    className="mgl4x"
                                    label={Config.lang('Ky')}
                                    labelProps={{ type: "h4", color: 'text/label' }}
                                    checked={Number(dataFilter?.IsPeriod) === 1}
                                    onChange={(e) => onChangeFilter("IsPeriod", e)}
                                />
                            </Col>
                            <Col xs={12} sm={8}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'PeriodFrom'}
                                    displayExpr={'PeriodName'}
                                    loading={cboPeriodFromLoading}
                                    disabled={dataFilter?.IsPeriod !== 1}
                                    dataSource={dataCboPeriodFromFilter}
                                    placeholder={Config.lang('Tu')}
                                    value={dataFilter?.PeriodFrom}
                                    className={'full_w'}
                                    onChange={e => onChangeFilter('PeriodFrom', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={2} className={"pdl0 display_row valign-middle"}>
                                <Typography className="mgr1x" type='p1' color={'text/label'} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                            </Col>
                            <Col xs={12} sm={10} className={"pdl0"}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'PeriodTo'}
                                    displayExpr={'PeriodName'}
                                    loading={cboPeriodToLoading}
                                    disabled={dataFilter?.IsPeriod !== 1}
                                    dataSource={dataCboPeriodToFilter}
                                    placeholder={Config.lang('Den')}
                                    value={dataFilter?.PeriodTo}
                                    onChange={e => onChangeFilter('PeriodTo', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={2}>
                        <Typography className="mgr4x" type='h4' color={'text/label'} style={{ whiteSpace: 'nowrap' }}>{Config.lang('Nhan_vien')}</Typography>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Dropdown
                            clearAble
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'SalesPersonID'}
                            displayExpr={'SalesPersonName'}
                            loading={cboSalesPersonLoading}
                            dataSource={dataCboSalesPerson}
                            value={dataFilter?.SalesPersonID}
                            onChange={e => onChangeFilter('SalesPersonID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={2}>
                        <Typography className="mgr4x" type='h4' color={'text/label'} style={{ whiteSpace: 'nowrap' }}>{Config.lang('Trang_thai')}</Typography>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Dropdown
                            clearAble
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'StatusID'}
                            displayExpr={'StatusName'}
                            loading={cboStatusLoading}
                            dataSource={dataCboStatus}
                            value={dataFilter?.StatusID}
                            onChange={e => onChangeFilter('StatusID', e)}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    };

    const checkEnableUpdateStatus = (dataList) => {
        const selectedRows = dataList.filter(item => item?.Choose === 1);
        if (selectedRows.length === 0) {
            setIsEnableUpdateStatus({IsEnable: false, dataIsCheck: []});
            return;
        }
        const canEnable = selectedRows.every(item => item?.IsManager === 1 || item?.IsManager === true);
        const checkRow = selectedRows.filter(item => item?.Choose);
        setIsEnableUpdateStatus({IsEnable: canEnable, dataIsCheck: checkRow});
    };

    const renderCheckbox = (e) => {
        const { rowType, data } = e || {};
        const isHeader = rowType === 'header';
        const value = isHeader ? isCheckedAll : e?.value;
        return <Checkbox
            disabled={isHeader ? checkBoxHeaderStatus : data?.IsPayment === 1}
            style={{ margin: 'auto' }}
            checked={!!value}
            onChange={(c) => {
                const val = +c?.value
                if (isHeader) {
                    const data = dataGrid.map((item, idx) => ({ ...item, STT: idx, Choose: item?.IsPayment === 1 ? item?.Choose : val }));
                    setDataGrid(data);
                    setIsCheckedAll(val);
                    checkEnableUpdateStatus(data);
                } else {
                    e.component.cellValue(e.rowIndex, 'Choose', val);
                    e.component.saveEditData();
                    let dataSource = e.component.option('dataSource') || [];
                    if (!!val) {
                        let dataSource = e.component.option('dataSource');
                        dataSource = dataSource.filter(item => !item?.IsPayment);
                        const dataSourceChecked = dataSource.filter(item => item?.Choose && !item?.IsPayment);
                        if (dataSource.length === dataSourceChecked.length) setIsCheckedAll(1); // Check ALL
                    } else setIsCheckedAll(0); // UnCheck All
                    checkEnableUpdateStatus(dataSource);
                }
            }}
        />;
    };

    const renderPaymentDescCol = (e) => {
        const { PaymentDesc = '', PaymentDescColor = '' } = e?.data;
        return <Typography lineClamp={3} hoverTooltip color={PaymentDescColor}>{PaymentDesc}</Typography>
    };

    const renderGrid = useMemo(() => {
        return (
            <GridContainer
                reference={ref => gridDetailRef.current = ref}
                isShowFilter
                dataSource={dataGrid}
                onAddNew={() => handleRedirect('add')}
                isPer={iPermission}
                buttonCRM={btnCRM}
                loading={formLoading}
                typePaging={'normal'}
                keyExpr={'STT'}
                pagerFullScreen
                itemPerPage={50}
                listPerPage={[50, 100, 150, 200]}
                valueSearch={search}
                onSearch={onSearch}
                filterRender={filterRender()}
                onOpenLoaded={onOpenLoaded}
                onOpenFilter={onOpenFilter}
                elementAttr={{ style: `height: ${openFilter ? (Config.getHeightGrid() + 4) - 222 : Config.getHeightGrid() - 86}px` }}
            >
                <Column
                    caption={Config.lang("Hanh_dong")}
                    visible={Config.isMobile}
                    alignment={"center"}
                    allowEditing={false}
                    cellRender={e => renderButtonAction(e)}
                />
                <Column
                    width={80}
                    dataType={'number'}
                    alignment={'center'}
                    allowFiltering={false}
                    allowSorting={false}
                    dataField={'Choose'}
                    headerCellRender={renderCheckbox}
                    cellRender={renderCheckbox}
                />
                <Column
                    width={320}
                    dataField={'CommissionRecipient'}
                    caption={Config.lang('Nguoi_huong')}
                />
                <Column
                    width={220}
                    dataField={'GroupSalesID'}
                    caption={Config.lang('Nhom_doi_tuong')}
                />
                <Column
                    width={280}
                    dataField={'VoucherNo'}
                    caption={Config.lang('So_phieu')}
                />
                <Column
                    width={180}
                    dataField={'CommissionDate'}
                    alignment={'center'}
                    dataType={'date'}
                    format={'dd/MM/yyyy'}
                    caption={Config.lang("Ngay_phieu")}
                />
                <Column
                    width={180}
                    dataType={'number'}
                    dataField={'PolicyAmount'}
                    alignment={'right'}
                    caption={Config.lang('Thanh_tien')}
                    calculateDisplayValue={(e) => Config.numberFormat(e?.PolicyAmount, 8)}
                />
                <Column
                    width={200}
                    dataField={'StatusName'}
                    caption={Config.lang('Trang_thai')}
                    cellRender={(e) => <Typography color={e?.data?.StatusColor}>{e?.value}</Typography>}
                />
                <Column
                    width={320}
                    dataField={'PaymentDesc'}
                    caption={Config.lang('Dien_giai_thanh_toan')}
                    cellRender={renderPaymentDescCol}
                />
                <Column
                    width={320}
                    dataField={'BankAccountName'}
                    caption={Config.lang('Ten_thu_huong')}
                />
                <Column
                    width={320}
                    dataField={'BankID'}
                    caption={Config.lang('Ngan_hang')}
                />
                <Column
                    width={320}
                    dataField={'BankAccountNo'}
                    caption={Config.lang('So_tai_khoan')}
                />
                <Column
                    width={320}
                    dataField={'TransactionOfficeBranch'}
                    caption={Config.lang('Chi_nhanh_PGD')}
                />
                <Column
                    fixed
                    minWidth={90}
                    fixedPosition={"right"}
                    visible={!Config.isMobile}
                    cellRender={e => renderButtonAction(e)}
                />
                <Summary>
                    <TotalItem
                        column={'PolicyAmount'} // Thanh tien
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                </Summary>
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, formLoading, dataCboPeriodFrom, dataCboPeriodTo, dataCboSalesPerson, dataCboGroupSales, cboGroupSaleLoading, cboSalesPersonLoading,
        dataCboStatus, cboStatusLoading, isCheckedAll, openFilter, checkBoxHeaderStatus, cboObjectLoading, dataCboObject ]);

    const getParamExport = () => {
        const params = [
            { "id": "UserID", "type": "VarChar", "value": Config.profile.UserID },
            { "id": "Language", "type": "VarChar", "value": Config.language || '84' },
            { "id": "DivisionID", "type": "VarChar", "value": Config.profile.DivisionID },
            { "id": "StrSearch", "type": "NVarChar", "value": search },
            { "id": "ReportTypeID", "type": "VarChar", "value": FormID },
        ];
        for (const property in dataFilter) {
            let type = 'NVarChar';
            if (['number', 'null'].includes(Config.typeOf(dataFilter[property]))) type = /from|to/i.test(property) ? 'DATETIME' : 'INT';
            else if (/from|to/i.test(property)) type = 'DATETIME';
            params.push({ "id": property, "type": type, "value": dataFilter[property] })
        }
        return params;
    };

    if (!iPermission) return null;
    
    return (
        <div className={'page-container-new'} style={{ height: '100vh' }}>
            <W14F1020UpdateStatus
                open={openUpdateStatus}
                onClose={(status) => {
                    setUpdateStatus(false);
                    if(status) loadGrid();
                }}
                dataUpdateStatus={dataCboUpdateStatus}
                loading={cboUpDateStatusLoading}
                dataFilter={dataFilter}
                dataCheck={isEnableUpdateStatus?.dataIsCheck}
            />
            <ActionToolbar title={Config.lang("Hoa_hong_ban_hang")} />
            <ButtonExport
                className="hide"
                ref={ref => exportRef.current = ref}
                reportTypeID={"W14F1020"}
                id={'slave1'}
                onlyShowPopup
                param={getParamExport()}
            />
            <Row><Col xs={12}>{renderGrid}</Col></Row>
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W14F1020Actions: bindActionCreators(W14F1020Actions, dispatch),
    W07F6699Actions: bindActionCreators(W07F6699Actions, dispatch),
    LoopRequestApiActions: bindActionCreators(LoopRequestApiActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W14F1020);


